import React from 'react';

function Header(props) {
  return (
    <header>
      <span role="img" aria-label="evcharge">
        🚙🔌🔋
      </span>
      <h1>
        {' '}Charge my ride{' '}
      </h1>
      <span role="img" aria-label="evcharge">
        🚙🔌🔋
      </span>
    </header >
  )
}

export default Header;